<template>
    <div class="news-content" id="news_img_area">
        <template v-if="info.seal_status == 2 && !is_owned">
            <div class="stop" :style="{fontSize: 0.32 * fontscale + 'rem'}"></div>
        </template>
        <template v-else>
             <div :style="{fontSize: 0.32 * fontscale + 'rem'}">
                <div v-html="emojis(info.maintext)"></div>
                <template v-if="info.free == '2' && info.feetext">
                    <div class="article-line">
                        <div class="line"></div>
                        <div class="article-fee">以下文字为付费内容，共计{info.length}字</div>
                        <div class="line"></div>
                    </div>
                </template>
                <div v-html="emojis(info.feetext || '')"></div>
            </div>
        </template>
      </div>
</template>

<script>
import { isAndroid, getCookie } from "../../utils/base"
import emoji from "../../utils/lib/emoji.js"
import unescapeHtml from "unescape-html"
export default {
    emoji,
    name: "Maintext",
    props: ["info", "is_owned"],
    data () {
        return {
            fontscale: 1
        }
    },
    methods: {
        emojis (item) {
            return emoji.toHtml(unescapeHtml(item))
        },
        setFontscale () {
            if (isAndroid()) {
                this.fontscale = getCookie("font_scale") || 1
            } else {
                this.fontscale = 1
            }
        }
    }
}
</script>
